import * as T from '../constants/types';

export const onChangeMapFilters = (key, value) => ({ type: T.CHANGE_MAP_FILTERS, payload: { [key]: value } });

// Атомарное обновление нескольких ключей mapFilters за один dispatch (напр. from/to диапазона
// таймлайна — чтобы applySimAccidentsStyle-подобные обработчики не читали рассинхронную пару).
export const onChangeMapFiltersMulti = payload => ({ type: T.CHANGE_MAP_FILTERS, payload });

export const onChangeParkingFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { parkingLotStatuses } } = getState();
    const uniqueStatuses = new Set(parkingLotStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('parkingLotStatuses', [ ...uniqueStatuses ]));
};

// Тогл «Вместимость парковки» слоя «Парковки Whoosh»: размер пунсона по вместимости вкл/выкл
export const onChangeParkingCapacitySizing = () => (dispatch, getState) => {
    const { mapFilters: { parkingCapacitySizing } } = getState();
    dispatch(onChangeMapFilters('parkingCapacitySizing', !parkingCapacitySizing));
};

export const onChangeParkingFilter1300 = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { parkings1300Statuses } } = getState();
    const uniqueStatuses = new Set(parkings1300Statuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('parkings1300Statuses', [ ...uniqueStatuses ]));
};

export const onChangeParkingsAlertsFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { parkingsAlerts } } = getState();
    const uniqueStatuses = new Set(parkingsAlerts);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('parkingsAlerts', [ ...uniqueStatuses ]));
};

// Filter for classified parkings
export const onChangeClassParkingFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { parkingClassLotStatuses } } = getState();
    const uniqueStatusesClass = new Set(parkingClassLotStatuses);
    (uniqueStatusesClass.has(value) && uniqueStatusesClass.size > 1) ? uniqueStatusesClass.delete(value) : uniqueStatusesClass.add(value);
    dispatch(onChangeMapFilters('parkingClassLotStatuses', [ ...uniqueStatusesClass ]));
};

export const onChangeClassifiedParkingsWeekdaysFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('classifiedParkingsWeekdaysStatuses', +value));
};

export const onChangeDowntimePeriodFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('aggScootersDowntimePeriodStatuses', +value));
};

export const onChangeClassifiedParkingsRebalancedWeekdaysFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('classifiedParkingsRebalancedWeekdaysStatuses', +value));
};

export const onChangeClassParkingDayPartFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('classifiedParkingDayPartStatuses', +value));
};

export const onChangeClassParkingDayPartRebalancedFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('classifiedParkingDayPartRebalancedStatuses', +value));
};

export const onChangeParkingsBookingsDateFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('parkingsBookingsDateStatuses', +value));
};

export const onChangeRechargingStatsPeriod = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('rechargingStatsPeriod', value));
};

export const onChangeAggFinishesFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('aggFinishesStatuses', value));
};

export const onChangeAggStartsFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('aggStartsStatuses', value));
};

export const onChangeAggDiffStartsFinishesFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('aggDiffStartsFinishesStatuses', value));
};

// Add filter for functional areas
export const onChangeFunctionalAreasFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { functionalAreasStatuses } } = getState();
    const uniqueStatusesAreas = new Set(functionalAreasStatuses);
    (uniqueStatusesAreas.has(value) && uniqueStatusesAreas.size > 1) ? uniqueStatusesAreas.delete(value) : uniqueStatusesAreas.add(value);
    dispatch(onChangeMapFilters('functionalAreasStatuses', [ ...uniqueStatusesAreas ]));
};

// Restriction Zones filter
export const onChangeRestrictionZonesFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { restrictionZonesStatuses } } = getState();
    const uniqueStatusesAreas = new Set(restrictionZonesStatuses);
    (uniqueStatusesAreas.has(value) && uniqueStatusesAreas.size > 1) ? uniqueStatusesAreas.delete(value) : uniqueStatusesAreas.add(value);
    dispatch(onChangeMapFilters('restrictionZonesStatuses', [ ...uniqueStatusesAreas ]));
};

export const onChangeRestrictionZonesV2Filter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { restrictionZonesV2Statuses } } = getState();
    const uniqueStatusesAreas = new Set(restrictionZonesV2Statuses);
    uniqueStatusesAreas.has(value) ? uniqueStatusesAreas.delete(value) : uniqueStatusesAreas.add(value);
    dispatch(onChangeMapFilters('restrictionZonesV2Statuses', [ ...uniqueStatusesAreas ]));
};

// DA-15115: тумблеры статуса (ACTIVE/INACTIVE/DELETED) для слоя «Фиче-зоны»
export const onChangeFeatureAreasFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { featureAreasStatuses } } = getState();
    const uniqueStatuses = new Set(featureAreasStatuses);
    uniqueStatuses.has(value) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('featureAreasStatuses', [ ...uniqueStatuses ]));
};

// Restriction Zones fictitious toggle filter
export const onChangeShowFictitiousZones = () => (dispatch, getState) => {
    const { mapFilters: { showFictitiousZones } } = getState();
    dispatch(onChangeMapFilters('showFictitiousZones', !showFictitiousZones));
};

// Restriction Zones technical toggle filter
export const onChangeShowTechnicalZones = () => (dispatch, getState) => {
    const { mapFilters: { showTechnicalZones } } = getState();
    dispatch(onChangeMapFilters('showTechnicalZones', !showTechnicalZones));
};

// Restriction Zones proposed toggle filter
export const onChangeShowProposedZones = () => (dispatch, getState) => {
    const { mapFilters: { showProposedZones } } = getState();
    dispatch(onChangeMapFilters('showProposedZones', !showProposedZones));
};

// Restriction Zones invisible toggle filter
export const onChangeShowInvisibleZones = () => (dispatch, getState) => {
    const { mapFilters: { showInvisibleZones } } = getState();
    dispatch(onChangeMapFilters('showInvisibleZones', !showInvisibleZones));
};

// Restriction Zones badge toggle filter
export const onChangeShowRestrictionZonesBadges = () => (dispatch, getState) => {
    const { mapFilters: { showRestrictionZonesBadges } } = getState();
    dispatch(onChangeMapFilters('showRestrictionZonesBadges', !showRestrictionZonesBadges));
};

// Restriction Zones badge toggle filter
export const onChangeShowRestrictionZonesV2Badges = () => (dispatch, getState) => {
    const { mapFilters: { showRestrictionZonesV2Badges } } = getState();
    dispatch(onChangeMapFilters('showRestrictionZonesV2Badges', !showRestrictionZonesV2Badges));
};

// Restriction Zones fill toggle filter
export const onChangeShowFillZones = () => (dispatch, getState) => {
    const { mapFilters: { showFillZones } } = getState();
    dispatch(onChangeMapFilters('showFillZones', !showFillZones));
};

// Restriction Zones FORBIDDEN existing toggle filter
export const onChangeShowForbiddenExistingZones = () => (dispatch, getState) => {
    const { mapFilters: { showForbiddenExistingZones } } = getState();
    dispatch(onChangeMapFilters('showForbiddenExistingZones', !showForbiddenExistingZones));
};

// Restriction Zones FORBIDDEN proposed toggle filter
export const onChangeShowForbiddenProposedZones = () => (dispatch, getState) => {
    const { mapFilters: { showForbiddenProposedZones } } = getState();
    dispatch(onChangeMapFilters('showForbiddenProposedZones', !showForbiddenProposedZones));
};

// Restriction Zones PERMITTED existing toggle filter
export const onChangeShowPermittedExistingZones = () => (dispatch, getState) => {
    const { mapFilters: { showPermittedExistingZones } } = getState();
    dispatch(onChangeMapFilters('showPermittedExistingZones', !showPermittedExistingZones));
};

// Restriction Zones PERMITTED proposed toggle filter
export const onChangeShowPermittedProposedZones = () => (dispatch, getState) => {
    const { mapFilters: { showPermittedProposedZones } } = getState();
    dispatch(onChangeMapFilters('showPermittedProposedZones', !showPermittedProposedZones));
};

// Add filter for Yandex and Urent functional areas
export const onChangeFunctionalAreasYandexUrentFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { functionalAreasYandexUrentStatuses } } = getState();
    const uniqueStatusesAreas = new Set(functionalAreasYandexUrentStatuses);
    (uniqueStatusesAreas.has(value) && uniqueStatusesAreas.size >= 1) ? uniqueStatusesAreas.delete(value) : uniqueStatusesAreas.add(value);
    dispatch(onChangeMapFilters('functionalAreasYandexUrentStatuses', [ ...uniqueStatusesAreas ]));
};

// Current scooters at parkings
export const onChangeCurrentScootersFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { currentScootersStatuses } } = getState();
    const uniqueStatuses = new Set(currentScootersStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('currentScootersStatuses', [ ...uniqueStatuses ]));
};

// Add filter for Lisboa zones
export const onChangeLisboaZonesFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { LisboaZonesStatuses } } = getState();
    const uniqueStatusesZones = new Set(LisboaZonesStatuses);
    (uniqueStatusesZones.has(value) && uniqueStatusesZones.size > 1) ? uniqueStatusesZones.delete(value) : uniqueStatusesZones.add(value);
    dispatch(onChangeMapFilters('LisboaZonesStatuses', [ ...uniqueStatusesZones ]));
};

export const onChangeIsochronesFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('parkingIsochrones', +value));
};

export const onChangeOaCompetitorsFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('oaCompetitorsDays', +value));
};

export const onChangeOaRotationFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('oaRotationDays', +value));
};

// Parking isochrones filter
export const onChangeIsochronesFilter2 = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { isochronesWithScootersFilterStatuses } } = getState();
    const uniqueStatuses = new Set(isochronesWithScootersFilterStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('isochronesWithScootersFilterStatuses', [ ...uniqueStatuses ]));
};

export const onChangeServiceCentersFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('serviceCentersIsochrones', +value));
};

export const onChangeAlertsTypeFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('AlertsTypesStatuses', +value));
};

export const onChangeAlertsDeviceFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('AlertsDeviceStatuses', +value));
};

// POI filter
export const onChangePoiFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { poiStatuses } } = getState();
    const uniqueStatuses = new Set(poiStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('poiStatuses', [ ...uniqueStatuses ]));
};

// POI source filter (DA-7087): тоглы OSM / AllThePlaces.xyz
export const onChangePoiSourceFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { poiSources } } = getState();
    const uniqueSources = new Set(poiSources);
    (uniqueSources.has(value) && uniqueSources.size > 1) ? uniqueSources.delete(value) : uniqueSources.add(value);
    dispatch(onChangeMapFilters('poiSources', [ ...uniqueSources ]));
};

// Scooters With Errors filter
export const onChangeSbWithErrorsFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { sbWithErrorsStatuses } } = getState();
    const uniqueStatuses = new Set(sbWithErrorsStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('sbWithErrorsStatuses', [ ...uniqueStatuses ]));
};

// DA-12966: потерянные самокаты
export const onChangeLostDevicesFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { lostDevicesStatuses } } = getState();
    const uniqueStatuses = new Set(lostDevicesStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('lostDevicesStatuses', [ ...uniqueStatuses ]));
};

// DA-12966: переключатель "показывать потери в Сервис Центрах"
export const onToggleLostDevicesServiceCenter = () => (dispatch, getState) => {
    const { mapFilters: { lostDevicesShowServiceCenter } } = getState();
    dispatch(onChangeMapFilters('lostDevicesShowServiceCenter', !lostDevicesShowServiceCenter));
};

// Вероятные призраки: круги радиусом accuracy вокруг показанной позиции
export const onToggleGhostDevicesShowAccuracy = () => (dispatch, getState) => {
    const { mapFilters: { ghostDevicesShowAccuracy } } = getState();
    dispatch(onChangeMapFilters('ghostDevicesShowAccuracy', !ghostDevicesShowAccuracy));
};

// Вероятные призраки: круги вокруг финиша радиусом расхождения самоката и телефона
export const onToggleGhostDevicesShowFinishAccuracy = () => (dispatch, getState) => {
    const { mapFilters: { ghostDevicesShowFinishAccuracy } } = getState();
    dispatch(onChangeMapFilters('ghostDevicesShowFinishAccuracy', !ghostDevicesShowFinishAccuracy));
};

// Вероятные призраки: самокаты в STAND_BY
export const onToggleGhostDevicesShowStandBy = () => (dispatch, getState) => {
    const { mapFilters: { ghostDevicesShowStandBy } } = getState();
    dispatch(onChangeMapFilters('ghostDevicesShowStandBy', !ghostDevicesShowStandBy));
};

// Вероятные призраки: самокаты в CHANGE_BATTERY (финиш — конец последней поездки)
export const onToggleGhostDevicesShowChangeBattery = () => (dispatch, getState) => {
    const { mapFilters: { ghostDevicesShowChangeBattery } } = getState();
    dispatch(onChangeMapFilters('ghostDevicesShowChangeBattery', !ghostDevicesShowChangeBattery));
};

// DEV → Поиск лостов: тумблеры классов и подслоёв
// класс A — умер на финише
export const onToggleLostSearchShowA = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowA } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowA', !lostSearchShowA));
};

// класс B — выбросы координат
export const onToggleLostSearchShowB = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowB } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowB', !lostSearchShowB));
};

// класс C — сместился < 1 км
export const onToggleLostSearchShowC = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowC } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowC', !lostSearchShowC));
};

// класс D1 — разрядился на финише
export const onToggleLostSearchShowD1 = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowD1 } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowD1', !lostSearchShowD1));
};

// класс D2 — пропал с живой батареей
export const onToggleLostSearchShowD2 = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowD2 } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowD2', !lostSearchShowD2));
};

// класс E — уехал > 1 км
export const onToggleLostSearchShowE = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowE } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowE', !lostSearchShowE));
};

// круги точности вокруг точек хвоста
export const onToggleLostSearchShowRadius = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowRadius } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowRadius', !lostSearchShowRadius));
};

export const onToggleLostSearchShowZone = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowZone } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowZone', !lostSearchShowZone));
};

// финиш последней поездки
export const onToggleLostSearchShowFinish = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowFinish } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowFinish', !lostSearchShowFinish));
};

// двойной кружок: подозрение на кражу
export const onToggleLostSearchShowTheft = () => (dispatch, getState) => {
    const { mapFilters: { lostSearchShowTheft } } = getState();
    dispatch(onChangeMapFilters('lostSearchShowTheft', !lostSearchShowTheft));
};


// DA-14587: типы ошибок геометрии операционных зон
export const onChangeOperationAreaErrType = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { operationAreaErrTypes } } = getState();
    const unique = new Set(operationAreaErrTypes);
    (unique.has(value) && unique.size > 1) ? unique.delete(value) : unique.add(value);
    dispatch(onChangeMapFilters('operationAreaErrTypes', [ ...unique ]));
};
// DA-14587: типы ошибок геометрии функциональных зон
export const onChangeFunctionalAreaErrType = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { functionalAreaErrTypes } } = getState();
    const unique = new Set(functionalAreaErrTypes);
    (unique.has(value) && unique.size > 1) ? unique.delete(value) : unique.add(value);
    dispatch(onChangeMapFilters('functionalAreaErrTypes', [ ...unique ]));
};
// DA-14587: переключатели групп операционных/функциональных зон
export const onToggleOpAreaErr = () => (dispatch, getState) => {
    const { mapFilters: { opAreaErrEnabled } } = getState();
    dispatch(onChangeMapFilters('opAreaErrEnabled', !opAreaErrEnabled));
};
export const onToggleFuncAreaErr = () => (dispatch, getState) => {
    const { mapFilters: { funcAreaErrEnabled } } = getState();
    dispatch(onChangeMapFilters('funcAreaErrEnabled', !funcAreaErrEnabled));
};
// DA-15433: переключатели двух половин слоя предложений по парковкам —
// полигоны спроса и точки парковок гасятся независимо друг от друга.
export const onToggleParkingProposalsHulls = () => (dispatch, getState) => {
    const { mapFilters: { parkingProposalsShowHulls } } = getState();
    dispatch(onChangeMapFilters('parkingProposalsShowHulls', !parkingProposalsShowHulls));
};
export const onToggleParkingProposalsPoints = () => (dispatch, getState) => {
    const { mapFilters: { parkingProposalsShowPoints } } = getState();
    dispatch(onChangeMapFilters('parkingProposalsShowPoints', !parkingProposalsShowPoints));
};

// DA-15309: переключатель 3D-экструзии зданий (по этажности) в легенде «Типология застройки»
export const onToggleUrbanTypologyExtrudeBuildings = () => (dispatch, getState) => {
    const { mapFilters: { urbanTypologyExtrudeBuildings } } = getState();
    dispatch(onChangeMapFilters('urbanTypologyExtrudeBuildings', !urbanTypologyExtrudeBuildings));
};

// Переключатель заливки зон («Типология зон») в легенде «Типология территорий»
export const onToggleUrbanTypologyShowZoneFill = () => (dispatch, getState) => {
    const { mapFilters: { urbanTypologyShowZoneFill } } = getState();
    dispatch(onChangeMapFilters('urbanTypologyShowZoneFill', !urbanTypologyShowZoneFill));
};

// Переключатель подслоя «Границы кварталов» в легенде «Типология территорий»
export const onToggleUrbanTypologyShowBlocks = () => (dispatch, getState) => {
    const { mapFilters: { urbanTypologyShowBlocks } } = getState();
    dispatch(onChangeMapFilters('urbanTypologyShowBlocks', !urbanTypologyShowBlocks));
};

// DA-15980: шторка сравнения источников слоя «Землепользование»
export const onToggleLanduseCompare = () => (dispatch, getState) => {
    const { mapFilters: { landuseCompare } } = getState();
    dispatch(onChangeMapFilters('landuseCompare', !landuseCompare));
};

// SpeedLimits Filter
export const onChangeSpeedLimitsFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { speedLimitsStatuses } } = getState();
    const uniqueStatuses = new Set(speedLimitsStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('speedLimitsStatuses', [ ...uniqueStatuses ]));
};

// Downtime filter
export const onChangeDowntimeFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { downtimeStatuses } } = getState();
    const uniqueStatuses = new Set(downtimeStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('downtimeStatuses', [ ...uniqueStatuses ]));
};

// Service centers filter
export const onChangeServiceCentersFilter2 = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { ServiceCentersStatuses } } = getState();
    const uniqueStatuses = new Set(ServiceCentersStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('ServiceCentersStatuses', [ ...uniqueStatuses ]));
};

// AnalyticAreas filter
export const onChangeAnalyticAreasFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('AnalyticArea', +value));
};

// Parking radius filter
export const onChangeParkingRadiusFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { parkingRadiusStatuses } } = getState();
    const uniqueStatuses = new Set(parkingRadiusStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size >= 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('parkingRadiusStatuses', [ ...uniqueStatuses ]));
};

// DA-14933 — выключение/включение ролей исполнителей в слое треков
export const onChangeScrTrackRolesFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { scrTrackRoles } } = getState();
    const roles = new Set(scrTrackRoles);
    roles.has(value) ? roles.delete(value) : roles.add(value);
    dispatch(onChangeMapFilters('scrTrackRoles', [ ...roles ]));
};

// DA-14933 — выключение/включение точек инфраструктуры (парковки/СЦ/зарядники) в слое треков
export const onChangeScrInfraFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { scrInfraKinds } } = getState();
    const kinds = new Set(scrInfraKinds);
    kinds.has(value) ? kinds.delete(value) : kinds.add(value);
    dispatch(onChangeMapFilters('scrInfraKinds', [ ...kinds ]));
};

// Panoramas filter
export const onChangePanoramasFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { panoramasStatuses } } = getState();
    const uniqueStatuses = new Set(panoramasStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size >= 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('panoramasStatuses', [ ...uniqueStatuses ]));
};

// Rotation visibility toggle
export const onChangeShowRotationFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { showRotationStatuses } } = getState();
    const uniqueStatuses = new Set(showRotationStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size >= 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('showRotationStatuses', [ ...uniqueStatuses ]));
};

// Parkings Alerts Device and Period filters
export const onChangeParkingsAlertsPeriodFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('parkingsAlertsPointsPeriodStatuses', +value));
};

export const onChangeParkingsAlertsTypeErrorFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('parkingsAlertsPointsTypeErrorStatuses', +value));
};

export const onChangeParkingsAlertsDeviceFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { ParkingsAlertsPointsDeviceStatuses } } = getState();
    const uniqueStatuses = new Set(ParkingsAlertsPointsDeviceStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('ParkingsAlertsPointsDeviceStatuses', [ ...uniqueStatuses ]));
};

export const onChangeCompetitorsRestrictionZonesFilter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { competitorsRestrictionZonesStatuses } } = getState();
    const uniqueStatuses = new Set(competitorsRestrictionZonesStatuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size > 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('competitorsRestrictionZonesStatuses', [ ...uniqueStatuses ]));
};

/**
 * Универсальный action creator для toggle динамического фильтра
 * @param {string} stateKeyDisabled - Ключ в Redux state для disabled значений
 * @returns {Function} - Thunk action
 */
export const createDynamicFilterToggleAction = stateKeyDisabled => ({ target: { value } }) => (dispatch, getState) => {
    const disabledValues = getState().mapFilters[stateKeyDisabled] || [];
    const disabledSet = new Set(disabledValues);
    // Toggle: если значение в disabled list - удаляем (включаем), иначе добавляем (отключаем)
    disabledSet.has(value) ? disabledSet.delete(value) : disabledSet.add(value);
    dispatch(onChangeMapFilters(stateKeyDisabled, [ ...disabledSet ]));
};

/**
 * Универсальный action creator для обновления доступных значений
 * @param {string} stateKeyAvailable - Ключ в Redux state для available значений
 * @returns {Function} - Thunk action
 */
export const createDynamicFilterUpdateAvailableAction = stateKeyAvailable => values => dispatch => {
    dispatch(onChangeMapFilters(stateKeyAvailable, values));
};

// Action creators для зон ограничений конкурентов (операторы)
export const onChangeCompetitorsRestrictionZonesOperatorsFilter = createDynamicFilterToggleAction('competitorsRestrictionZonesOperatorsDisabled');

// Action creators для зон катания конкурентов (операторы)
export const onChangeRidingZonesCompetitorsOperatorsFilter = createDynamicFilterToggleAction('ridingZonesCompetitorsOperatorsDisabled');
export const updateRidingZonesCompetitorsAvailableOperators = createDynamicFilterUpdateAvailableAction('ridingZonesCompetitorsAvailableOperators');

// Action creator для агрегированных стартов конкурентов (только легенда, без переключателей)
export const updateTrackStartsCompetitorsAvailableOperators = createDynamicFilterUpdateAvailableAction('trackStartsCompetitorsAvailableOperators');

// Action creator для стартов по операционным зонам конкурентов (только легенда, без переключателей)
export const updateOaCompetitorsAvailableOperators = createDynamicFilterUpdateAvailableAction('oaCompetitorsAvailableOperators');

// DA-12016: Action creators для тематической раскладки по операционным зонам (Статистики по зонам)
export const onChangeOaRotationMetric = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('oaRotationMetric', value));
};
export const updateOaRotationAvailableOperators = createDynamicFilterUpdateAvailableAction('oaRotationAvailableOperators');
export const onChangeOaRotationOperatorFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('oaRotationOperator', value));
};

// Action creators для парковок конкурентов (DA-13627)
export const onChangeCompetitorsParkingsOperatorsFilter = createDynamicFilterToggleAction('competitorsParkingsOperatorsDisabled');
export const updateCompetitorsParkingsAvailableOperators = createDynamicFilterUpdateAvailableAction('competitorsParkingsAvailableOperators');

// Action creators для перебросок флота конкурентов (DA-13611)
export const onChangeCompetitorsFleetTransfersOperatorsFilter = createDynamicFilterToggleAction('competitorsFleetTransfersOperatorsDisabled');
export const updateCompetitorsFleetTransfersAvailableOperators = createDynamicFilterUpdateAvailableAction('competitorsFleetTransfersAvailableOperators');
export const onChangeCompetitorsFleetTransfersShowScooters = () => (dispatch, getState) => {
    const { mapFilters: { competitorsFleetTransfersShowScooters } } = getState();
    dispatch(onChangeMapFilters('competitorsFleetTransfersShowScooters', !competitorsFleetTransfersShowScooters));
};
export const onChangeCompetitorsFleetTransfersShowBicycles = () => (dispatch, getState) => {
    const { mapFilters: { competitorsFleetTransfersShowBicycles } } = getState();
    dispatch(onChangeMapFilters('competitorsFleetTransfersShowBicycles', !competitorsFleetTransfersShowBicycles));
};
export const onChangeCompetitorsFleetTransfersDateMode = mode => dispatch => {
    dispatch(onChangeMapFilters('competitorsFleetTransfersDateMode', mode));
};
export const onChangeCompetitorsFleetTransfersSelectedDate = date => dispatch => {
    dispatch(onChangeMapFilters('competitorsFleetTransfersSelectedDate', date));
};
export const updateCompetitorsFleetTransfersAvailableDates = createDynamicFilterUpdateAvailableAction('competitorsFleetTransfersAvailableDates');
export const updateCompetitorsFleetTransfersDateOperators = createDynamicFilterUpdateAvailableAction('competitorsFleetTransfersDateOperators');

// DA-14686: Action creators для изменений зон конкурентов
export const onChangeCompetitorsZonesChangesOperatorsFilter = createDynamicFilterToggleAction('competitorsZonesChangesOperatorsDisabled');
export const updateCompetitorsZonesChangesAvailableOperators = createDynamicFilterUpdateAvailableAction('competitorsZonesChangesAvailableOperators');
export const onChangeCompetitorsZonesChangesTypeFilter = createDynamicFilterToggleAction('competitorsZonesChangesDisabledTypes');
export const onChangeCompetitorsZonesChangesPeriod = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('competitorsZonesChangesPeriod', Number(value)));
};

// DA-15432: Action creators для изменений парковок конкурентов
export const onChangeCompetitorsParkingsChangesOperatorsFilter = createDynamicFilterToggleAction('competitorsParkingsChangesOperatorsDisabled');
export const updateCompetitorsParkingsChangesAvailableOperators = createDynamicFilterUpdateAvailableAction('competitorsParkingsChangesAvailableOperators');
export const onChangeCompetitorsParkingsChangesTypeFilter = createDynamicFilterToggleAction('competitorsParkingsChangesDisabledTypes');
export const onChangeCompetitorsParkingsChangesPeriod = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('competitorsParkingsChangesPeriod', Number(value)));
};

// Update available operators based on loaded data (restriction zones)
export const updateCompetitorsRestrictionZonesAvailableOperators = operators => dispatch => {
    dispatch(onChangeMapFilters('competitorsRestrictionZonesAvailableOperators', operators));
};

// DA-15115 — слой треков: список исполнителей из загруженных тайлов + выбор исполнителя.
export const updateScrTracksAvailableExecutors = executors => dispatch => {
    dispatch(onChangeMapFilters('scrTracksAvailableExecutors', executors));
};
export const setScrTracksSelectedExecutor = executorId => dispatch => {
    dispatch(onChangeMapFilters('scrTracksSelectedExecutor', executorId));
};

// Rotation2 visibility toggle
export const onChangeShowRotation2Filter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { showRotation2Statuses } } = getState();
    const uniqueStatuses = new Set(showRotation2Statuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size >= 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('showRotation2Statuses', [ ...uniqueStatuses ]));
};

export const onChangeOaRotation2Filter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('oaRotation2Days', +value));
};

// V2 visibility toggle
export const onChangeShowRotationV2Filter = ({ target: { value } }) => (dispatch, getState) => {
    const { mapFilters: { showRotationV2Statuses } } = getState();
    const uniqueStatuses = new Set(showRotationV2Statuses);
    (uniqueStatuses.has(value) && uniqueStatuses.size >= 1) ? uniqueStatuses.delete(value) : uniqueStatuses.add(value);
    dispatch(onChangeMapFilters('showRotationV2Statuses', [ ...uniqueStatuses ]));
};

export const onChangeOaRotationV2Filter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('oaRotationV2Days', +value));
};

// Filter for H3 Zoom in Aggregated Tracks August
export const onChangeAggTracksH3ZoomFilter = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('aggTracksAugustH3Zoom', value));
};

// Mode toggle for the combined Таба/Форкаст layer ('forecast' | 'taba')
export const onChangeRebalanceForecastTabaMode = ({ target: { value } }) => dispatch => {
    dispatch(onChangeMapFilters('rebalanceForecastTabaMode', value));
};

// Включение/выключение фильтров по минимальному порогу ребаланса — отдельно для избытка и дефицита
export const onChangeRebalanceMinGapUpEnabled = () => (dispatch, getState) => {
    const { mapFilters: { rebalanceMinGapUpEnabled } } = getState();
    dispatch(onChangeMapFilters('rebalanceMinGapUpEnabled', !rebalanceMinGapUpEnabled));
};

export const onChangeRebalanceMinGapDownEnabled = () => (dispatch, getState) => {
    const { mapFilters: { rebalanceMinGapDownEnabled } } = getState();
    dispatch(onChangeMapFilters('rebalanceMinGapDownEnabled', !rebalanceMinGapDownEnabled));
};

// Включение/выключение фильтра «только парковки без самокатов» (cnt_scooters = 0)
export const onChangeRebalanceOnlyEmptyEnabled = () => (dispatch, getState) => {
    const { mapFilters: { rebalanceOnlyEmptyEnabled } } = getState();
    dispatch(onChangeMapFilters('rebalanceOnlyEmptyEnabled', !rebalanceOnlyEmptyEnabled));
};

// DA-13054: Административные границы OSM
export const onChangeOsmAdminBoundariesLevelsFilter = createDynamicFilterToggleAction('osmAdminBoundariesLevelsDisabled');
export const updateOsmAdminBoundariesAvailableLevels = createDynamicFilterUpdateAvailableAction('osmAdminBoundariesAvailableLevels');
export const onChangeOsmAdminBoundariesShowLabels = () => (dispatch, getState) => {
    const { mapFilters: { osmAdminBoundariesShowLabels } } = getState();
    dispatch(onChangeMapFilters('osmAdminBoundariesShowLabels', !osmAdminBoundariesShowLabels));
};

// Слой «Границы города»: тумблер «Только активные города»
export const onChangeCityBoundariesOnlyActive = () => (dispatch, getState) => {
    const { mapFilters: { cityBoundariesOnlyActive } } = getState();
    dispatch(onChangeMapFilters('cityBoundariesOnlyActive', !cityBoundariesOnlyActive));
};

// rebalance-chains: Статистика цепочек трипов
export const onChangeChainStatsMinCount = value => dispatch => {
    dispatch(onChangeMapFilters('chainStatsMinCount', value));
};
// Переключатель median/max — по какой глубине цепочки (median_chain_length/max_chain_length)
// взвешивать размер точки на уровне 0 (см. CHAIN_STATS_RADIUS_BY_MEDIAN/_BY_MAX в
// constants/layers.js) и по какому полю фильтровать слайдером «Длина цепочки не менее».
export const onChangeChainStatsSizeMetric = value => dispatch => {
    dispatch(onChangeMapFilters('chainStatsSizeMetric', value));
};
// Слайдер «Число поездок через парковку не менее» (фильтр по total_trips, только уровень 0 —
// см. CHAIN_STATS_MIN_TOTAL_TRIPS_STOPS в constants/layers.js).
export const onChangeChainStatsMinTotalTrips = value => dispatch => {
    dispatch(onChangeMapFilters('chainStatsMinTotalTrips', value));
};
// Кнопка «Назад ко всем парковкам» в легенде — полный сброс открытой цепочки/подсветки
// (по образцу clearSelectedShift у слоя «Треки исполнителей»).
export const onClearChainStatsSelection = () => dispatch => {
    dispatch(onChangeMapFiltersMulti({
        chainStatsSelectedParkingId: null,
        chainStatsSelectedParkingStats: null,
        chainStatsHighlightedNodeId: null,
    }));
};
